import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';

import { SelectPlayerFlowType } from '../../../types';

import styles from './index.module.scss';

interface ModalDescriptionProps {
  flowType?: SelectPlayerFlowType;
  isSettingsFinished: boolean;
  isNeedPayment: boolean;
  isAddressWithStreamDisabled?: boolean;
}

const ModalDescription: FC<ModalDescriptionProps> = ({
  isSettingsFinished,
  isNeedPayment,
  flowType,
  isAddressWithStreamDisabled,
}) => {
  if (!isSettingsFinished) {
    return <div className={styles.description}>{TEXTS.MODAL_BIND_SUCCESS_POINT_CREATE_DESC}</div>;
  }

  if (flowType === SelectPlayerFlowType.CHANGE_DEVICE) {
    const successBindDeviceDescription = isAddressWithStreamDisabled
      ? TEXTS.MODAL_BIND_DEVICE_SUCCESS_NON_ACTIVE_DESC
      : TEXTS.MODAL_BIND_SUCCESS_DESC;

    return <div className={styles.description}>{successBindDeviceDescription}</div>;
  }

  const successBindStreamDescription = isNeedPayment
    ? TEXTS.MODAL_BIND_SUCCESS_NON_ACTIVE_DESC
    : TEXTS.MODAL_BIND_SUCCESS_DESC;

  return <div className={styles.description}>{successBindStreamDescription}</div>;
};

export default memo(ModalDescription);
